import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const Won_lost = ({ newStatus, onSet }) => {
    const [description, setDescription] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [purchasingOrder, setPurchasingOrder] = useState('');

    const headerClass = newStatus === 2 ? 'bg-success' : 'bg-danger';
    const headerText = newStatus === 2 ? 'WON' : 'LOST';

    const handleSubmit = (e) => {
        e.preventDefault();

     
        if (newStatus === 3  && (selectedType === '' || selectedType === '0')){
            alert("Select a type");
            return;
        }
        if (newStatus === 2  && (purchasingOrder === '')){
            alert("Purchasing Order number is required");
            return;
        }
        if (description === ''){
            alert("Description is mandatory");
            return;
        }

        let additionalInfo = '';

        if (newStatus === 3) {
            additionalInfo = " (" + selectedType + ")";
        } else if (newStatus === 2) {
            additionalInfo = " PO:" + purchasingOrder;
        }
        
        const finalDescription = additionalInfo + "   " + description;
        onSet(
            finalDescription
        );
    };

    const handleChange = (e) => {
        // Accede al elemento <select>
        const selectElement = e.target;
        // Obtén el índice de la opción seleccionada
        const selectedIndex = selectElement.selectedIndex;
        // Obtén el texto (label) de la opción seleccionada
        const selectedLabel = selectElement.options[selectedIndex].text;
    
        setSelectedType(selectedLabel); // Guarda el label en tu estado
      };

    return (
        <div>
            <div className={`${headerClass} text-white text-center p-2 rounded-top`}>
                <h3 className="m-0">{headerText}</h3>
            </div>
            <Form className="border p-4 rounded-bottom" onSubmit={handleSubmit}>
                {newStatus === 3 ? (
                    <Form.Group className="mb-3">
                        <Form.Label>Selecciona el objeto:</Form.Label>
                        <Form.Select value={selectedType} onChange={handleChange}>
                            <option value="0">Select an option</option>
                            <option value="1">High price</option>
                            <option value="2">Payment method</option>
                            <option value="3">Postponed</option>
                            <option value="4">Competitor</option>
                            <option value="5">Other</option>
                        </Form.Select>
                    </Form.Group>
                ) : (
                    <Form.Group className="mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Invoice Number"
                            value={purchasingOrder}
                            onChange={(e) => setPurchasingOrder(e.target.value)}
                        />
                    </Form.Group>
                )}

                <Form.Group className="mb-3">
                    <Form.Label>Description:</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Write a description for record here"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Form.Group>

                <div className="d-grid">
                    <Button variant="success" type="submit" >
                        Save new status
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default Won_lost;
